module.exports = "/_next/static/resources/life2-24e6c7a1809ba80dd810cd4373964727.jpg";